import { Injectable } from '@angular/core';
import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CleanupTestRegistrationsModalComponent } from './cleanup-test-registrations-modal.component';

@DwAction({ keyName: 'cleanup-test-registrations', display: 'Clean up test registrations', actionType: DwActionType.menuAction,
    isGlobal: true, allowOnce: true, configData: { requireValidation: false, redirectAfter: false, actionMessage: '' } })
@Injectable()
export class CleanupTestRegistrationsActionService implements DwActionHandler {
    constructor(private modal: DwModalService) {}
    handleAction(state: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const rows = state.metaDataGridApi.getSelectedRows();
        const ids = Array.isArray(rows) ? rows.map(r => +r.UserChallengeId).filter(id => Number.isInteger(id) && id > 0) : [];
        if (!ids.length) { const result = new DwActionResult(); result.success = false;
            result.message = 'Select at least one registration using the grid checkboxes.'; return of(result); }
        const config = new DwModalConfig<any>();
        config.title = 'Clean up test registrations'; config.component = CleanupTestRegistrationsModalComponent;
        config.data = { userChallengeIds: Array.from(new Set(ids)) };
        config.buttons = DwModalButtonStandardConfigs.instance.SaveAndCancel; config.modalSize = DwModalSize.responsive;
        return this.modal.showModal(config).pipe(map(value => {
            const result = new DwActionResult(); result.cancelled = value.cancelled; result.success = !value.cancelled && !!value.data;
            if (result.success) { state.metaDataGridApi.refreshDataSource(true); result.message = 'Test orders and registrations removed. The streakers can register again.'; }
            return result;
        }));
    }
}
